import {Experience} from "@/core/interfaces/experience/Experience";

interface TierProgress {
    /** The total amount of experience needed to reach the next tier */
    totalToReach: number;
    /** The total amount of experience reached in the current tier */
    totalReached: number;
    /** The progress between the current and next tier between 0 and 1 */
    progress: number;
}

/**
 * Experience service.
 *
 * @constructor
 */
export default function() {
    /**
     * Calculate the progress between the current and next tier
     *
     * @param  {Experience} experience - The experience object
     *
     * @return {number} - The progress between the current and next tier
     */
    const progress = (experience: Experience): TierProgress => {
        const totalToReach = experience.tiers.next
            ? experience.tiers.next.threshold - experience.tiers.current.threshold
            : 0;
        const totalReached = experience.tiers.next
            ? experience.value - experience.tiers.current.threshold
            : 0;

        return {
            totalToReach,
            totalReached,
            progress: totalToReach ? (totalReached / totalToReach) : 1
        };
    };

    return {
        progress
    };
};
